export enum Role {
    ADMIN = 'ADMIN',
    CALLING_AGENT = 'CALLING_AGENT',
    SALES_AGENT = 'SALES_AGENT',
}

export enum LeadAssignmentStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    COMPLETED = "COMPLETED",
  }